import React from "react";

import {
  AuthContext,
  AuthContextAttributes
} from "src/contexts/AuthContext";

export const useAuthContext = (): AuthContextAttributes => React.useContext(AuthContext);